// /docs — landing page that lists every doc section with a brief description.
// Mirrors the sidebar layout so the index reinforces the nav model.

import { Link } from 'react-router-dom'
import { NAV } from '../../docs/registry.js'

const SUMMARIES = {
  quickstart:
    'Install, sign in, init a repo, record a flow, run it. The minimum path to your first passing test.',
  'graph-driven-testing':
    'The model: nodes are screens, edges are user actions, paths are tests. Ammann & Offutt vocab.',
  'voice-tips':
    'How to talk during `cairn record` so the LLM gets your flow right on the first take.',
  'drift-workflow':
    '`cairn scan` → drift report → `cairn accept`. The loop that keeps the graph honest.',
  'schema-reference': 'Auto-generated from `@cairntools/schema`. Every field, every constraint.',
  'cli-reference': 'Auto-generated from `@cairntools/cli`. Every command, every flag.',
}

export function DocsIndex() {
  return (
    <article className="docs-content">
      <h1 className="text-3xl font-semibold text-[var(--color-basalt)]">Documentation</h1>
      <p className="mt-2 text-sm text-[var(--color-schist)]">
        Everything you need to ship with Cairn.
      </p>

      <div className="mt-10 space-y-10">
        {NAV.sections.map((section) => (
          <section key={section.title}>
            <h2 className="mb-4 text-xs font-medium uppercase tracking-wider text-[var(--color-schist)]">
              {section.title}
            </h2>
            <ul className="space-y-1">
              {section.items.map((item) => (
                <li key={item.slug}>
                  <Link
                    to={`/docs/${item.slug}`}
                    className="block rounded-md px-3 py-2 hover:bg-[var(--color-sandstone)]/40"
                  >
                    <div className="flex items-center gap-2">
                      <span className="font-medium text-[var(--color-basalt)]">{item.label}</span>
                      {item.generated && (
                        <span className="rounded-sm bg-[var(--color-sandstone)] px-1.5 py-0.5 text-[10px] uppercase tracking-wider text-[var(--color-slate)]">
                          auto-generated
                        </span>
                      )}
                    </div>
                    {SUMMARIES[item.slug] && (
                      <p className="mt-0.5 text-xs text-[var(--color-schist)]">
                        {SUMMARIES[item.slug]}
                      </p>
                    )}
                  </Link>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </article>
  )
}
